// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicImage_root__0R5bM","image":"BasicImage_image__w3ouv","imageLink":"BasicImage_imageLink__QY4tl"};